<template>
  <div class="container" :style="isScroll?'background-color:white;border-bottom:1px solid #d5d5d5;':''">
    <div class="content">
      <img class="logo" @click="jump('/mainPage')" src="@/assets/images/logo.png" alt="">
      <div>
        <ul class="navList">
          <li class="navItem" @click="jump('/mainPage')">
            <span :class="$route.fullPath.includes('mainPage')?'navItem-title-active':'navItem-title-default'">首页</span>
          </li>
          <li class="navItem" @mouseenter="enterItem(1)" @mouseleave="enterItem(-1)">
            <span @click="jump('/aboutUs')" :class="$route.fullPath.includes('/aboutUs')?'navItem-title-active':'navItem-title-default'">关于我们</span>
            <div class="floatWindow" v-if="showNavItem == 1">
              <!-- <div class="windowContent">
                <div class="windowLeft context">
                  <div class="window-context-title">关于我们</div>
                  <div class="window-context-subtitle">专注检测研发·致力于成为世界一流的化学品评价机构</div>
                  <div class="window-ab">
                    <div class="window-ab-left">
                      <div class="window-selection window-ab-selection-active" @click="jump('/aboutUs/enterpriseIntroduction')">
                        <div class="window-selection-left">
                          <div class="window-selection-circle"></div>
                          <div class="window-selection-title">企业简介</div>
                        </div>
                        <div class="window-selection-right">
                          <div class="window-selection-arrow"></div>
                        </div>
                      </div>
                      <div class="window-selection window-ab-selection-default" @click="jump('/aboutUs/developmentHistory')">
                        <div class="window-selection-left">
                          <div class="window-selection-circle"></div>
                          <div class="window-selection-title">发展历程</div>
                        </div>
                        <div class="window-selection-right">
                          <div class="window-selection-arrow"></div>
                        </div>
                      </div>
                      <div class="window-selection window-ab-selection-default" @click="jump('/aboutUs/laboratory')">
                        <div class="window-selection-left">
                          <div class="window-selection-circle"></div>
                          <div class="window-selection-title">健安德实验室</div>
                        </div>
                        <div class="window-selection-right">
                          <div class="window-selection-arrow"></div>
                        </div>
                      </div>
                    </div>
                    <div class="window-ab-right">
                      <div class="window-selection window-ab-selection-default" @click="jump('/aboutUs/enterpriseCulture')">
                        <div class="window-selection-left">
                          <div class="window-selection-circle"></div>
                          <div class="window-selection-title">企业文化</div>
                        </div>
                        <div class="window-selection-right">
                          <div class="window-selection-arrow"></div>
                        </div>
                      </div>
                      <div class="window-selection window-ab-selection-default" @click="jump('/aboutUs/honor')">
                        <div class="window-selection-left">
                          <div class="window-selection-circle"></div>
                          <div class="window-selection-title">资质荣誉</div>
                        </div>
                        <div class="window-selection-right">
                          <div class="window-selection-arrow"></div>
                        </div>
                      </div>
                      <div class="window-selection window-ab-selection-default" @click="jump('/aboutUs/contactUs')">
                        <div class="window-selection-left">
                          <div class="window-selection-circle"></div>
                          <div class="window-selection-title">联系我们</div>
                        </div>
                        <div class="window-selection-right">
                          <div class="window-selection-arrow"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="windowRight windowRight-ab">
                  <div class="windowRight-ab-left" @click="jump('/aboutUs/contactUs')">
                    <img src="@/assets/images/image26.png" alt="">
                    <div class="windowRight-ab-left-title">联系健安德</div>
                    <div class="windowRight-ab-left-subTitle">仅需1步 即刻定制您的解决方案</div>
                    <div class="windowRight-ab-left-more">
                      <div class="windowRight-ab-left-more-text">查看详情</div>
                      <div class="windowRight-ab-left-more-arrow"></div>
                    </div>
                  </div>
                  <div class="windowRight-ab-right">
                    <img src="@/assets/images/image27.png" alt="">
                    <div class="windowRight-ab-left-title">新闻资讯</div>
                    <div class="windowRight-ab-left-subTitle">新闻 · 活动 · 记录</div>
                    <div class="windowRight-ab-left-more">
                      <div class="windowRight-ab-left-more-text">查看详情</div>
                      <div class="windowRight-ab-left-more-arrow"></div>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="windowContent">
                <div class="windowLeft">
                  <img class="windowLeft-common-img" src="@/assets/images/image130.png" alt="">
                </div>
                <div class="windowRight">
                  <div class="windowRight-common-title">关于我们</div>
                  <!-- <div class="windowRight-common-subtitle">核心及差异化优势，为您提供高品质的综合性科技服务</div> -->
                  <div class="windowRight-common-selection">
                    <div class="window-selection windowRight-common-selection-default" @click="jump('/aboutUs/enterpriseIntroduction')">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">企业简介</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                    <div class="window-selection windowRight-common-selection-default" @click="jump('/aboutUs/enterpriseCulture')">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">企业文化</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                    <div class="window-selection windowRight-common-selection-default" @click="jump('/aboutUs/developmentHistory')">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">发展历程</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                    <!-- <div class="window-selection windowRight-common-selection-default" @click="jump('/aboutUs/laboratory')">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">健安德实验室</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div> -->
                    <div class="window-selection windowRight-common-selection-default" @click="jump('/aboutUs/honor')">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">资质荣誉</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                    <div class="window-selection windowRight-common-selection-default" @click="jump('/aboutUs/contactUs')">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">联系我们</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <li class="navItem" @mouseenter="enterItem(2)" @mouseleave="enterItem(-1)">
            <span @click="jump('/ourService')" :class="$route.fullPath.includes('/ourService')?'navItem-title-active':'navItem-title-default'">我们的服务</span>
            <div class="floatWindow" v-if="showNavItem == 2">
              <div class="windowContent">
                <div class="windowLeft">
                  <img class="windowLeft-common-img" src="@/assets/images/image28.png" alt="">
                </div>
                <div class="windowRight">
                  <div class="windowRight-common-title">我们的服务</div>
                  <!-- <div class="windowRight-common-subtitle">核心及差异化优势，为您提供高品质的综合性科技服务</div> -->
                  <div class="windowRight-common-selection">
                    <div class="window-selection windowRight-common-selection-active" @click="jump('/ourService/ourServicePesticide')">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">农药登记试验</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                    <div class="window-selection windowRight-common-selection-default" @click="jump('/ourService/chemicalRegister')">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">新化学物质登记试验</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                    <div class="window-selection windowRight-common-selection-default" @click="jump('/ourService/makeUp')">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">化妆品注册和备案检验</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                    <div class="window-selection windowRight-common-selection-default" @click="jump('/ourService/otherService')">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">其他服务</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!-- <li class="navItem" @mouseenter="enterItem(3)" @mouseleave="enterItem(-1)">
            <span class="navItem-title-default">新闻资讯</span>
            <div class="floatWindow" v-if="showNavItem == 3">
              <div class="windowContent">
                <div class="windowLeft">
                  <img class="windowLeft-common-img" src="@/assets/images/image29.png" alt="">
                </div>
                <div class="windowRight">
                  <div class="windowRight-common-title">新闻资讯</div>
                  <div class="windowRight-common-subtitle">核心及差异化优势，为您提供高品质的综合性科技服务</div>
                  <div class="windowRight-common-selection">
                    <div class="window-selection windowRight-common-selection-active">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">公司新闻</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                    <div class="window-selection windowRight-common-selection-default">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">行业资讯</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                    <div class="window-selection windowRight-common-selection-default">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">通知公告</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li> -->
          <li class="navItem" @mouseenter="enterItem(4)" @mouseleave="enterItem(-1)">
            <span @click="jump('/joinUs')" :class="$route.fullPath.includes('/joinUs')?'navItem-title-active':'navItem-title-default'">加入我们</span>
            <div class="floatWindow" v-if="showNavItem == 4">
              <div class="windowContent">
                <div class="windowLeft">
                  <img class="windowLeft-common-img" src="@/assets/images/image30.png" alt="">
                </div>
                <div class="windowRight">
                  <div class="windowRight-common-title">加入我们</div>
                  <div class="windowRight-common-subtitle">核心及差异化优势，为您提供高品质的综合性科技服务</div>
                  <div class="windowRight-common-selection">
                    <!-- <div class="window-selection windowRight-common-selection-active">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">职业发展</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div> -->
                    <div class="window-selection windowRight-common-selection-default" @click="jump('/joinUs')">
                      <div class="window-selection-left">
                        <div class="window-selection-circle"></div>
                        <div class="window-selection-title">招聘专栏</div>
                      </div>
                      <div class="window-selection-right">
                        <div class="window-selection-arrow"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
          <!-- <img class="icon" src="@/assets/images/search.png" alt=""> -->
          <!-- <img class="icon" src="@/assets/images/customerService.png" alt=""> -->
          <!-- <div class="navLogin">登录</div> -->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  data () {
    return {
      isScroll: false,
      showNavItem: -1
    }
  },
  watch:{
    showNavItem(newVal,oldVal){
      if(newVal != -1){
        this.isScroll = true
      }else{
        this.handleScroll(this.isScroll)
      }
    }
  },
  methods: {
    handleScroll(e){
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop > 0){
        this.isScroll = true
      }else{
        this.isScroll = false
      }
    },
    enterItem(navItem){
      this.showNavItem = navItem
    },
    jump(path){
      this.$router.push(path)
      this.showNavItem = -1
    }
  },
  mounted() {
  	// 向页面添加滚动事件
    window.addEventListener('scroll', this.handleScroll, true);
  },
}
</script> 

<style lang='less' scoped>
  .container{
    height: 90px;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.5);
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    box-sizing: border-box;
    .content{
      width: 1440px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .logo{
        width: 200px;
        height: 38px;
        cursor: pointer;
      }
      .navList{
        display: flex;
        align-items: center;
        height: 90px;
        li{
          cursor: pointer;
          height: 100%;
          display: flex;
          align-items: center;
          &>span:hover{
            color: #DB0000 !important;
            font-weight: bold;
          }
        }
        .navItem{
          padding: 0px 25px;
          .navItem-title-default{
            color: #666666;
            height: 100%;
            line-height: 90px;
          }
          .navItem-title-active{
            color: #DB0000;
            font-weight: bold;
            height: 100%;
            line-height: 90px;
          }
        }
        .icon{
          height: 24px;
          width: 24px;
          margin-right: 30px;
          cursor: pointer;
        }
        .navLogin{
          height: 32px;
          width: 100px;
          background-color: #DB0000;
          text-align: center;
          color: white;
          line-height: 32px;
          border-radius: 5px;
          margin-left: 50px;
          cursor: pointer;
        }
        .floatWindow{
          width: 100%;
          // height: 420px;
          padding: 30px 0;
          background-color: #ffffff;
          position: absolute;
          left: 0;
          top: 90px;
          box-shadow: 0px 3px 6px 1px rgb(199, 199, 199);
          .windowContent{
            width: 1500px;
            // height: 340px;
            margin: 0 auto;
            // margin-top: 35px;
            display: flex;
            .windowLeft{
              height: 100%;
              width: 540px;
              border-radius: 15px;
              margin-right: 140px;
            }
            .windowLeft-common-img{
              width: 540px;
              height: 300px;
            }
            .context{
              background-color: #DB0000;
              box-sizing: border-box;
              padding: 30px 40px 40px 40px;
              .window-context-title{
                font-size: 32px;
                color: white;
                font-weight: bold;
                letter-spacing: 3px;
              }
              .window-context-subtitle{
                color: #ffdada;
                font-size: 14px;
                margin-top: 3px;
              }
              .window-ab{
                margin-top: 60px;
                color: white;
                display: flex;
                justify-content: space-between;
                // .window-ab-selection-active{
                // }
                // .window-ab-selection-default{
                //   color: white;
                //   opacity: .5;
                // }
                & .window-selection:hover{
                  opacity: 1;
                }
                & .window-selection{
                  opacity: .5;
                }
              }
            }
            .window-selection{
              width: 220px;
              height: 34px;
              border-bottom: 1px solid white;
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: 14px;
              box-sizing: border-box;
              padding-bottom: 13px;
              margin-bottom: 15px;
              cursor: pointer;
              .window-selection-left{
                display: flex;
                align-items: center;
                .window-selection-circle{
                  height: 10px;
                  width: 10px;
                  border-radius: 50%;
                  background-color: #fff;
                  margin-right: 20px;
                }
                .window-selection-title{
                  font-size: 18px;
                  font-weight: bold;
                }
              }
              .window-selection-right{
                .window-selection-arrow{
                  width: 7px;
                  height: 7px;
                  border-top: 1px solid white;
                  border-right: 1px solid white;
                  transform: rotate(45deg);
                }
              }
            }
            .windowRight-ab{
              display: flex;
              flex-grow: 1;
              justify-content: space-between;
            }
            .windowRight{
              .windowRight-common-title{
                font-size: 30px;
                font-weight: bold;
                width: 100%;
              }
              .windowRight-common-subtitle{
                margin-top: 10px;
                font-size: 15px;
                color: #333333;
              }
              .windowRight-common-selection{
                margin-top: 60px;
                .window-selection{
                  width: 350px;
                  margin-right: 30px;
                  color: #333333;
                  border-bottom: 1px solid #333333;
                  float: left;
                  .window-selection-circle{
                    background-color: #333333;
                  }
                  .window-selection-arrow{
                    border-color: #333333;
                  }
                  &:hover{
                    color: #DB0000;
                    border-bottom: 1px solid #DB0000;
                    .window-selection-circle{
                      background-color: #DB0000;
                    }
                    .window-selection-arrow{
                      border-color: #DB0000;
                    }
                  }
                }
                // .windowRight-common-selection-active{
                //   color: #DB0000;
                //   border-bottom: 1px solid #DB0000;
                //   float: left;
                //   .window-selection-circle{
                //     background-color: #DB0000;
                //   }
                //   .window-selection-arrow{
                //     border-color: #DB0000;
                //   }
                // }
                // .windowRight-common-selection-default{
                //   color: #333333;
                //   border-bottom: 1px solid #333333;
                //   float: left;
                //   .window-selection-circle{
                //     background-color: #333333;
                //   }
                //   .window-selection-arrow{
                //     border-color: #333333;
                //   }
                // }
              }
              .windowRight-ab-left,.windowRight-ab-right{
                width: 390px;
                height: 100%;
                position: relative;
                .windowRight-ab-left-title{
                  margin-top: 12px;
                  font-size: 30px;
                  font-weight: bold;
                }
                .windowRight-ab-left-subTitle{
                  margin-top: 3px;
                  font-size: 15px;
                }
                .windowRight-ab-left-more{
                  display: flex;
                  align-items: center;
                  position: absolute;
                  bottom: 0;
                  color: #DB0000;
                  cursor: pointer;
                  .windowRight-ab-left-more-text{
                    font-size: 14px;
                    margin-right: 10px;
                  }
                  .windowRight-ab-left-more-arrow{
                    width: 7px;
                    height: 7px;
                    border-top: 1px solid #DB0000;
                    border-right: 1px solid #DB0000;
                    transform: rotate(45deg);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
</style>
